/**
 * Router navigation `state` an opener passes when the reader's own click opens a message on the Email
 * tab, asking that tab to mark the message read. Read back by {@link isClarityEmailMarkReadNavigation}.
 */
export const CLARITY_EMAIL_MARK_READ_NAVIGATION_STATE = { clarityEmailMarkRead: true } as const;
